//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { formatEmployeeName } from './OrderAdmittanceFunctions.js'
import TableEmployees from './../Employee/TableEmployees.vue'

export default {
  components: {
    TableEmployees: TableEmployees
  },
  props: {
    orderAdmittance: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data: function () {
    return {
      formatEmployeeName: formatEmployeeName,
      selectedEmployee: null,
      employeeTable: '',
      modalOpened: false
    }
  },
  computed: {
    readonly: function () {
      return this.orderAdmittance.state !== 'AD0' && this.orderAdmittance.state !== 'AD1' && this.orderAdmittance.state !== 'AD2'
    }
  },
  methods: {
    onShowReceivingEmployeeTable: function () {
      if (this.readonly) {
        return
      }
      this.employeeTable = 'receivingEmployeeTable'
      this.selectedEmployee = this.orderAdmittance.receivingEmployee
      this.modalOpened = true
    },
    saveReceivingEmployee: function (employee) {
      if (!this.orderAdmittance.receivingEmployee) {
        this.orderAdmittance.receivingEmployee = {}
      }
      this.orderAdmittance.receivingEmployee.fio = employee.shortName
      this.orderAdmittance.receivingEmployee.key = employee.key
      this.orderAdmittance.receivingEmployee.position = employee.positionName
      this.closeModal()
    },
    closeModal: function () {
      this.modalOpened = false
      this.selectedEmployee = null
    }
  }
}

